import { render } from "./BusinessData.vue?vue&type=template&id=027d9a92&scoped=true"
import script from "./BusinessData.vue?vue&type=script&lang=js"
export * from "./BusinessData.vue?vue&type=script&lang=js"

import "./BusinessData.vue?vue&type=style&index=0&id=027d9a92&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027d9a92"]])

export default __exports__